// Shared currency formatter — display only, never used for math.
// Always renders 2 decimals with thousands separators:
//   843.6  -> "843.60"
//   2156.4 -> "2,156.40"
//   0      -> "0.00"
// Use this for every displayed dollar figure so formatting stays consistent.
export const formatMoney = (n) =>
  (Number(n) || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// A reward or other round amount said the way people say it: "$100", never "$100.00". Keeps
// cents only when there are some ("$62.50"). Money on a receipt or a total stays formatMoney.
export const formatDollars = (n) =>
  `$${(Number(n) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;

// Canonical US-Eastern timestamp formatter — DISPLAY ONLY, never used for math.
// Renders a stored UTC ISO string in America/New_York with an explicit " ET"
// suffix so admin, editor and staff all see the SAME canonical value regardless
// of their browser timezone (this is the fix for the activity-log date dispute).
//   formatEastern("2026-05-23T04:30:18Z")                 -> "May 23, 2026, 12:30 AM ET"
//   formatEastern("2026-05-23T04:30:18Z", {dateOnly:true})-> "May 23, 2026 ET"
// Empty / unparseable input returns "" (never throws).
export const formatEastern = (iso, { dateOnly = false } = {}) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const opts = dateOnly
    ? { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric' }
    : { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true };
  return d.toLocaleString('en-US', opts) + ' ET';
};
